import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedResourceTypeModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related resource type value"
    okText="ADD RESOURCE TYPE VALUE"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a resource type value"
      queryVariables={{ typeId: FILTER_TYPE.RESOURCE_TYPE.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Resource type value is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedResourceTypeModal.Item = Item;

export default RelatedResourceTypeModal;
